<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 添加人才输送信息 </template>
    <div class="page-content">
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              label-width="120px"
              :rules="formRules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="球员姓名"
                    prop="playerName"
                    :rules="[{ required: true, message: '必填项' }]"
                  >
                    <el-input
                      v-model="form.playerName"
                      class="w255"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="证件号"
                    prop="idNumber"
                    :rules="[{ required: true, message: '必填项' }]"
                  >
                    <el-input
                      v-model="form.idNumber"
                      class="w255"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item
                    label="输出教练姓名"
                    prop="coachOutPuts"
                    :rules="[{ required: true, message: '请选择输出教练姓名' }]"
                  >
                    <el-select
                      v-model.trim="form.coachOutPuts"
                      filterable
                      allow-create
                      default-first-option
                      multiple
                      style="width: 100%"
                      placeholder="请选择输出教练姓名，可输入姓名搜索教练姓名，如不存在，可输入姓名创建新教练姓名。"
                    >
                      <el-option
                        v-for="(item, index) in coachOption"
                        :key="index"
                        :label="item.idName"
                        :value="item.uuid"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="form.idType !== 'IDNUMBER'">
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      label="出生日期"
                      prop="birthday"
                      :data-value="form.birthday"
                      :rules="[{ required: true, message: '必填项' }]"
                    >
                      <el-date-picker
                        v-model="form.birthday"
                        class="w255"
                        align="right"
                        type="date"
                        value-format="timestamp"
                        placeholder="选择日期"
                        :picker-options="birthdayPickerOptions"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="性别" prop="gender" :rules="[{ required: true, message: '必填项' }]">
                      <el-select v-model="form.gender" filterable class="w255" placeholder="选择性别">
                        <el-option v-for="item in genderList" :key="item.key" :label="item.key" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">注册记录信息</legend>
                <div class="player-list-wrapper" v-for="(playerItem, index) in form.registerListInfos" :key="index">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item label="注册在本机构的起止日期" label-width="205px" :prop="`registerListInfos.${index}.registerStart`" :rules="[{ required: true, message: '必填项' }]">
                        <el-date-picker v-model="playerItem.registerStart" style="width:166px;" align="right" type="month" value-format="timestamp" placeholder="选择日期" @focus="datePickerOfStart(playerItem)" :picker-options="registerStartPickerOptions"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="13">
                      <el-form-item label="截止日期" label-width="115px" :prop="`registerListInfos.${index}.registerEnd`" :rules="playerItem.zhijin === 'Y' ? [] : [{ required: true, message: '必填项' }]" class="yioks-switch">

                        <el-switch
                          v-model="playerItem.zhijin"
                          active-text="选择日期"
                          active-color="#4cd964"
                          active-value="N"
                          inactive-text="至今"
                          inactive-value="Y"
                          @change="isZhijinChange(index)"
                        ></el-switch>
                        <el-date-picker
                          v-model="playerItem.registerEnd"
                          type="month"
                          placeholder="选择日期"
                          :value-format="'timestamp'"
                          v-if="playerItem.zhijin === 'N'"
                          @focus="datePickerOfEnd(playerItem)"
                          :picker-options="registerEndPickerOptions"
                          style="width:166px;margin-left:5px"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <template v-if="playerItem.zhijin ==='N'">
                    <el-row>
                      <el-col :span="6">
                        <el-form-item
                          label="是否转会"
                          label-width="95px"
                          class="yioks-switch"
                        >
                          <el-switch
                            v-model="playerItem.isTransfer"
                            active-color="#4cd964"
                            active-text="是"
                            inactive-text="否"
                            active-value="是"
                            inactive-value="否"
                            @change="isTransferChange(index)"
                          ></el-switch>
                        </el-form-item>
                      </el-col>
                      <template v-if="playerItem.isTransfer === '是'">
                        <el-col :span="8">
                          <el-form-item label="已转会至" label-width="95px" :prop="`registerListInfos.${index}.youthUuid`" :rules="[{ required: true, message: '必填项' }]">
                            <el-select v-model="playerItem.youthUuid" filterable class="w380" placeholder="选择转会机构" @change="youthChange(index)">
                              <el-option v-for="item in youthShortNameList" :key="item.youthUuid" :label="item.youthName" :value="item.youthUuid"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <template v-if="playerItem.youthUuid==='其他'">
                            <el-form-item label="输入机构名称" label-width="135px" :prop="`registerListInfos.${index}.youthShortName`" :rules="[{ required: true, message: '必填项' }]">
                              <el-input v-model="playerItem.youthShortName" style="width:195px" placeholder="输入机构名称" maxlength="100" show-word-limit></el-input>
                            </el-form-item>
                          </template>
                        </el-col>
                      </template>
                    </el-row>
                  </template>
                  <el-row class="updateFilesYioks">
                    <el-col :span="24">
                      <el-form-item label="证明文件" :rules="[{ required: true }]">
                        <el-upload
                          :action="uploadFileUrl"
                          :on-success="(res, file, fileList)=> fileUploadSuccess(res, file, fileList,index)"
                          :before-upload="(file) => fileUploadBefore(file,index)"
                          :on-remove="(file, fileList) => fileRemove(file,fileList,index)"
                          :on-exceed="handleExceed"
                          :limit="10"
                          :file-list="playerItem.fileList"
                        >
                          <el-button size="small" type="primary" >点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">请上传证明文件，且不超过10M，最多上传10个文件</div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" style="display:flex;justify-content:flex-end;margin-bottom:10px;align-items: center">
                      <div>
                        <span style="color:#f88594">注：如存在多次转入转出记录，请点击“+”分别添加。</span>
                      </div>
                      <div>
                        <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="handleAddPlayerList" style="padding:10px"></el-button>
                      </div>
                      <div v-if="!(form.registerListInfos.length === 1 && index == 0)" style="margin-left:10px">
                        <el-button type="danger" icon="el-icon-remove-outline" circle @click="handleDeletePlayerList(index)" style="padding:10px"></el-button>
                      </div>

                    </el-col>
                  </el-row>
                </div>
              </fieldset>

              <fieldset class="vita-form-fieldset">
                <legend style="margin-left:20px">输送信息</legend>
                <div class="player-list-wrapper" v-for="(activityItem, index) in form.activityListInfos" :key="index">
                  <span>
                  {{index+1}} ：
                </span>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item
                        label="类型"
                        label-width="90px"
                        :prop="`activityListInfos.${index}.activityTypeEnum`"
                        :rules="[{ required: true, message: '必填项', }]"
                      >
                        <el-select v-model="activityItem.activityTypeEnum" style="width:147px" placeholder="选择类型" @change="checkType(index)">
                          <el-option v-for="item in weatherList" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="开始日期" label-width="90px" :prop="`activityListInfos.${index}.activityStart`" :rules="[{ required: true, message: '必填项' }]">
                        <el-date-picker v-model="activityItem.activityStart" style="width:100%;" align="right" type="date" value-format="timestamp" placeholder="选择日期" @focus="datePickerOfStartActivity(activityItem)" :picker-options="activityStartPickerOptions"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="结束日期" label-width="90px" :prop="`activityListInfos.${index}.activityEnd`" :rules="['CLUBTRAIN','CLUBTEAM'].includes(activityItem.activityTypeEnum) ? [] : [{ required: true, message: '必填项' }]" class="yioks-switch">
                        <el-date-picker
                          v-model="activityItem.activityEnd"
                          type="date"
                          placeholder="选择日期"
                          :value-format="'timestamp'"
                          @focus="datePickerOfEndActivity(activityItem)"
                          :picker-options="activityEndPickerOptions"
                          style="width:100%;"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="15">
                      <el-form-item
                        label="官方录取通知标题"
                        label-width="155px"
                        :prop="`activityListInfos.${index}.activityName`"
                        :rules="[{ required: true, message: '必填项' }]"
                      >
                        <el-input
                          v-model="activityItem.activityName" :placeholder="activityItem.activityNameTitle" maxlength="100" show-word-limit
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item
                        label="地点"
                        label-width="60px"
                        :prop="`activityListInfos.${index}.activityAddress`"
                        :rules="[{ required: true, message: '必填项' }]"
                      >
                        <el-input
                          v-model="activityItem.activityAddress" placeholder="请输入地点" maxlength="100" show-word-limit
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="updateFilesYioks">
                    <el-col :span="24">
                      <el-form-item label="证明文件" label-width="90px" :rules="[{ required: true }]">
                        <el-upload
                          :action="uploadFileUrl"
                          :on-success="(res, file, fileList)=> fileUploadSuccessActivity(res, file, fileList,index)"
                          :before-upload="(file) => fileUploadBefore(file,index)"
                          :on-remove="(file, fileList) => fileRemoveActivity(file,fileList,index)"
                          :on-exceed="handleExceed"
                          :limit="10"
                          :file-list="activityItem.fileList"
                        >
                          <el-button size="small" type="primary" >点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">请上传证明文件，且不超过10M，最多上传10个文件</div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" style="display:flex;justify-content:flex-end;margin-bottom:10px;align-items: center">
                      <div>
                        <span style="color:#f88594">注：如球员涉及输送至各级多种情况，请将不同情况中反应最高水平的经历点击“+”分别添加</span>
                      </div>
                      <div>
                        <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="handleAddActivityList" style="padding:10px"></el-button>
                      </div>
                      <div v-if="!(form.activityListInfos.length === 1 && index == 0)" style="margin-left:10px">
                        <el-button type="danger" icon="el-icon-remove-outline" circle @click="handleDeleteActivityList(index)" style="padding:10px"></el-button>
                      </div>

                    </el-col>
                  </el-row>
                </div>
              </fieldset>
            </el-form>
          </div>
        </vue-scroll>
        <yioks-tips
          :showTip="tipsFlag"
          tipMsg="请确认是否提交？"
          :loading="repeatSubmit"
          @callback="hideTipsDialog"
        ></yioks-tips>
        <yioks-tips
          :showTip="tipsFlagCancel"
          tipMsg="请确认放弃保存并返回吗？"
          :loading="repeatSubmitCancel"
          @callback="hideTipsDialogCancel"
        ></yioks-tips>
      </div>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="tempSave">提交</el-button>
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
  </SubContent>
</template>

<script>
  import center from "@/api/center";
  import { calculateMonthDifference,hasOverlap,isTimestampInRange,getLastDayOfMonth } from "@/utils/commen";
  import playerTalentSend from "@/api/playerTalentSend";
  import storage from "@/utils/storage";
  import {filterIdNumber} from "@/utils/yioks_filter";
  import {genderList} from "@/utils/yioks_data";
  import {activityTypeEnumList} from "@/assets/js/yioksSelect";
  import player from "@/api/player";
  import squad from '@/api/squad';

  export default {
  name: "ScoutList",

  data() {
    return {
      genderList,
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      tipsFlagNext: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 1,
      uploadFileUrl : "/api/zuxie/guozi/upload/uploadJixiaoFile",
      form: {
        playerName: "",
        idNumber: "",
        birthday: "",
        idType: this.$route.query.idType.trim().toUpperCase() || "",
        gender: "",
        trainTimes: "",
        coachOutPuts: [],
        registerListInfos:[
          {
            registerStart: "",
            registerEnd: "",
            isTransfer: "",
            youthShortName: "",
            youthUuid: "",
            zhijin:"Y",
            fileList:[],
          } // //临时数据
        ],
        activityListInfos:[
          {
            activityStart: "",
            activityEnd: "",
            activityName: "",
            activityTypeEnum: "",
            activityAddress: "",
            fileList:[],
            activityNameTitle:"请输入名称（全称）",
          } // //临时数据
        ],
      },
      youthShortNameList: [],
      coachOption: [],
      formRules: {},
      weatherList: activityTypeEnumList,
      pickerStart: '',
      pickerEnd: '',
      pickerStartActivity: '',
      pickerEndActivity: '',
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  computed: {
    player_name() {
      return this.$route.query.player_name.trim() || "";
    },
    player_id_number() {
      return this.$route.query.player_id_number.trim().toUpperCase() || "";
    },
//    idType() {
//      return this.$route.query.idType.trim().toUpperCase() || "";
//    },
    playerUuid() {
      return this.$route.query.playerUuid.trim() || "";
    },
    // 时间选择器
    birthdayPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          return time.getTime() > new Date().getTime();
        },
      };
    },
    // 注册开始时间选择器 只能选2015-01-01之后的
    registerStartPickerOptions() {
      const pickerEnd = this.pickerEnd;
      if(pickerEnd) {
        return {
          disabledDate(time) {
            return  time.getTime() < 1420041601000 || time.getTime() > pickerEnd || time.getTime() > new Date().getTime();
          },
        }
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < 1420041601000 || time.getTime() > new Date().getTime();
          },
        }
      }
    },
    // 注册结束时间选择器 只能选2015-01-01之后的
    registerEndPickerOptions() {
      const pickerStart = this.pickerStart;
      if(pickerStart) {
        return {
          disabledDate(time) {
            return  time.getTime() < pickerStart ;
          },
        }
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < 1420041601000 ;
          },
        }
      }
    },
    // 活动开始时间选择器 只能选2022-01-01之后的
    activityStartPickerOptions() {
      const pickerEndActivity = this.pickerEndActivity;
      if(pickerEndActivity) {
        return {
          disabledDate(time) {
            return  time.getTime() < 1640966399000 || time.getTime() > pickerEndActivity || time.getTime() > new Date().getTime();
          },
        }
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < 1640966399000 || time.getTime() > new Date().getTime();
          },
        }
      }
    },
    // 活动结束时间选择器
    activityEndPickerOptions() {
      const pickerStartActivity = this.pickerStartActivity;
      if(pickerStartActivity) {
        return {
          disabledDate(time) {
            return  time.getTime() < pickerStartActivity ;
          },
        }
      } else {
        return {
          disabledDate(time) {
            return time.getTime() < 1640966399000 ;
          },
        }
      }
    },
  },

  created() {

    this.getYouthShortNameList();
    this.getCoachNameList();

  },

  mounted() {
    if(this.playerUuid){
      this.loadPlayerInfo();
    }
    this.setFormData();
  },

  methods: {
    /* 获取球员信息 */
    loadPlayerInfo() {
      player
      .getPlayerInfo(this.playerUuid)
      .then((res) => {
        const { idType,birthday,gender } = res.user;
        if (idType) this.$set(this.form, "idType", idType);
        if (this.form.idType === 'IDNUMBER') {
          const birthday = filterIdNumber(this.player_id_number, 0); //filterIdNumber
          const birthdayTimestamp = new Date(birthday).getTime();
          this.$set(this.form, "birthday", birthdayTimestamp);
          const gender = filterIdNumber(this.player_id_number, 1); //filterIdNumber
          this.$set(this.form, "gender", gender);
        }else{
          if (birthday) this.$set(this.form, "birthday", birthday);
          if (gender) this.$set(this.form, "gender", gender);
        }
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
    checkType(index){
      if(this.form.activityListInfos[index].activityTypeEnum === '国家队'){
        this.form.activityListInfos[index].activityNameTitle = '请输入国家队录取通知全称';
      }
      if(this.form.activityListInfos[index].activityTypeEnum === '全运会'){
        this.form.activityListInfos[index].activityNameTitle = '请输入全运会录取通知全称';
      }
      if(this.form.activityListInfos[index].activityTypeEnum === '职业俱乐部'){
        this.form.activityListInfos[index].activityNameTitle = '请输入俱乐部全称';
      }
    },
    datePickerOfStart(val) {
      const {registerEnd } = val;

      if(registerEnd){
        this.pickerEnd = registerEnd;
      }  else {
        this.pickerEnd = null;
      }
    },
    datePickerOfEnd(val) {
      const {registerStart} = val;

      if(registerStart){
        this.pickerStart = registerStart;
      }  else {
        this.pickerStart = null;
      }
    },

    datePickerOfStartActivity(val) {
      const {activityEnd } = val;

      if(activityEnd){
        this.pickerEndActivity = activityEnd;
      }  else {
        this.pickerEndActivity = null;
      }
    },
    datePickerOfEndActivity(val) {
      const {activityStart} = val;

      if(activityStart){
        this.pickerStartActivity = activityStart;
      }  else {
        this.pickerStartActivity = null;
      }
    },
    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传10个文件，本次上传已经超过了限制。`);
    },
    fileUploadSuccess( res, file, fileList, index ) {
      let { registerListInfos } = this.form;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.form.registerListInfos[index].fileList.push(fileObj)
    },
    /* 文件上传校验 */
    fileUploadBefore(file) {
      const fileReg = /^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i
      const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 10;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过10M");
        return false;
      }
      if (!fileType) {
        this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件");
        return false;
      }
      return fileLimit;
    },
    fileRemove(file, fileList,index) {
      let { registerListInfos } = this.form;
      this.form.registerListInfos[index].fileList = fileList;
    },
    fileUploadSuccessActivity( res, file, fileList, index ) {
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
        fileType: suffix
      };
      this.form.activityListInfos[index].fileList.push(fileObj)
    },

    fileRemoveActivity(file, fileList,index) {
      this.form.activityListInfos[index].fileList = fileList;
    },
    isZhijinChange(index){
      this.form.registerListInfos[index].registerEnd = '';
      this.form.registerListInfos[index].isTransfer = '';
      this.form.registerListInfos[index].youthUuid = '';
      this.form.registerListInfos[index].youthShortName = '';
      this.$refs["form"].clearValidate();
    },
    isTransferChange(index){
      this.form.registerListInfos[index].youthUuid = '';
      this.form.registerListInfos[index].youthShortName = '';
      this.$refs["form"].clearValidate();
    },
    youthChange(index){
      this.form.registerListInfos[index].youthShortName = '';
      this.$refs["form"].clearValidate();
    },
    handleAddPlayerList() {
      let { registerListInfos } = this.form;
      registerListInfos.push({
        registerStart: "",
        registerEnd: "",
        isTransfer: "",
        youthShortName: "",
        youthUuid: "",
        zhijin:"Y",
        fileList:[],
      });
      this.$set(this.form, "registerListInfos", registerListInfos);
    },
    handleDeletePlayerList(index) {
      let { registerListInfos } = this.form;
      registerListInfos.splice(index, 1);
      this.$set(this.form, "registerListInfos", registerListInfos);
    },
    handleAddActivityList() {
      let { activityListInfos } = this.form;
      activityListInfos.push({
        activityStart: "",
        activityEnd: "",
        activityName: "",
        activityTypeEnum: "",
        activityAddress: "",
        fileList:[],
        activityNameTitle:"请输入名称（全称）",
      });
      this.$set(this.form, "activityListInfos", activityListInfos);
    },
    handleDeleteActivityList(index) {
      let { activityListInfos } = this.form;
      activityListInfos.splice(index, 1);
      this.$set(this.form, "activityListInfos", activityListInfos);
    },
    /* 提交球探信息 */ ///
    submitData(status) {

    },
    getYouthShortNameList(){
      center.getAllYouthList().then((res) => {
        this.youthShortNameList = res.concat({youthUuid:'其他',youthName:'其他'});
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
    getCoachNameList(){
      squad.getCoachListYouthAll().then((res) => {
        this.coachOption = res.coachOptionVos;
      })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },

    /* 保存 */
    tempSave() {
      let { registerListInfos,activityListInfos } = this.form;
      let noneFile = false;
      let noneActiveTime = false; // 是否有不在注册时间段内的活动记录
      // 顺便计算一下注册在本机构的所有时长
      this.form.trainTimes = "";// 先清空 再计算
      let monthDifference = 0;
      // 再校验一下时间段是否有交集
      let timePeriods = [];

      // 所有注册时间段数组
      let registerTimes = [];

      registerListInfos.map(item=>{
        if(item.fileList.length === 0){
          noneFile = true;
        }
        if(item.registerStart){
          if(!item.registerEnd){
            monthDifference = monthDifference + Number(calculateMonthDifference(item.registerStart,new Date().getTime()) + 1);
          }else{
            monthDifference = monthDifference + Number(calculateMonthDifference(item.registerStart,item.registerEnd) + 1);
          }

          timePeriods.push({start:item.registerStart,end:item.registerEnd ? item.registerEnd : new Date().getTime()});
//          let end = item.registerEnd ? item.registerEnd : new Date().getTime();
//          registerTimes.push({start:item.registerStart,end:getLastDayOfMonth(end)});
        }
      });
      this.form.trainTimes = monthDifference;

      if(hasOverlap(timePeriods)){
        this.$message.error("注册时间有冲突，请检查所有的注册时间段");
        return
      }

      activityListInfos.map(item=>{
        if(item.fileList.length === 0){
          noneFile = true;
        }

//        if(item.activityStart && timePeriods.length>0){
//          if(!isTimestampInRange(item.activityStart,registerTimes)){
//            noneActiveTime = true
//          }
//        }
      });

      if(noneFile){
        this.$message.error("请检查所有的证明文件是否上传");
        return
      }

//      if(noneActiveTime){
//        this.$message.error("有活动记录不在注册时间段内，请核实所有的活动记录时间");
//        return
//      }


      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlag = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    /* 暂时保存 */
    hideTipsDialog(ok) {
      if (ok) {
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              let coachNames = [];
              this.form.coachOutPuts.map(ite => {
                let coachName = this.coachOption.find((item) => item.uuid === ite)?.idName;
                if (coachName) {
                  coachNames.push(coachName);
                }else {
                  coachNames.push(ite);
                }
              });
              let {playerName,coachOutPuts,idNumber,birthday,idType,gender, trainTimes,registerListInfos,activityListInfos } = this.form;
              let talentSend = {
                playerName,
                coachOutPutUuid: coachOutPuts && coachOutPuts.length ? coachOutPuts.join(",") : "",
                coachOutPutName: coachNames && coachNames.length ? coachNames.join(",") : "",
                idNumber,
                birthday,
                idType,
                gender,
                trainTimes
              }
              const aimData = {
                talentSend,
                registerListInfos,
                activityListInfos
              };
              playerTalentSend.addTalentSend(aimData).then((res) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                if (res.code) {
                  this.$message.error(res.msg);
                } else {
                  this.$router.go(-1);
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                console.log(err);
              });
            }
          });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true;
    },
    hideTipsDialogCancel(ok) {
      if (ok) {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
        this.$router.go(-1);
      } else {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
      }
    },

    /* 填写内容 */
    setFormData() {
      // const moment = require('moment');
      this.$set(this.form, "playerName", this.player_name);
      this.$set(this.form, "idNumber", this.player_id_number);
//      this.$set(this.form, "idType", this.idType);
      if (this.form.idType === 'IDNUMBER') {
        const birthday = filterIdNumber(this.player_id_number, 0); //filterIdNumber
        const birthdayTimestamp = new Date(birthday).getTime();
        this.$set(this.form, "birthday", birthdayTimestamp);
        const gender = filterIdNumber(this.player_id_number, 1); //filterIdNumber
        this.$set(this.form, "gender", gender);
      }

    },

  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  height 550px
  .vita-form-fieldset
    margin: 0 0 20px 0;
    padding: 10px 10px 0;
    border: 1px dashed $color_white;
    width: 97%
.step-box
  margin-top 10px
.btn_wrap
  width 100%
  display flex
  justify-content center
.w380
  width 180px
.w255
  width 255px
.w150
  width 160px
.player-list-wrapper
  width 100%
  display block
  justify-content space-around
  border-bottom 1px dashed #ccc

  padding 10px 0 0 0
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
</style>

<style lang="stylus">
.page-content
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
  .el-form-item__label
    color #fff
    font-size 16px
</style>
<style lang="stylus">
@import '~@/assets/css/variable'
.yioks-switch
  .el-switch__label
    color $color_white
  .el-switch__label--left
    &.is-active
      color $green_color
  .el-switch__label--right
    &.is-active
      color $green_color
.yioks-switch-grey
  .el-switch__label
    color $grey_color
  .el-switch__label--left
    &.is-active
      color $grey_color
  .el-switch__label--right
    &.is-active
      color $green_color
.updateFilesYioks
  .el-upload__tip
    color white
  .el-upload-list__item-name
    color white
</style>
